import React, { useEffect, useState } from "react";
import { Chip } from "@mui/material";

const ButtonPress1Widget = ({ widget, onValueUpdate }) => {
  const [value, setValue] = useState(null);
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    if (!widget) return;
    setWidgetData(widget);

    if (widget.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setValue(
        currentValue === "" || currentValue === null ? "idle" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!value) return "idle";
    return value;
  };

  const getChipColor = () => {
    switch (value) {
      case "pressed":
      case "long pressed":
      case "double pressed":
      case "triple pressed":
      case "4x pressed":
        return "secondary";
      case "idle":
        return "default";
      default:
        return "default";
    }
  };

  return (
    <Chip
      label={getStatusText()}
      color={getChipColor()}
      variant="contained"
      sx={{
        width: "100%",
        fontWeight: 500,
        fontSize: "0.875rem",
        textTransform: "capitalize",
      }}
    />
  );
};

export default ButtonPress1Widget;
